import { CampaignsController } from './campaigns.controller'
import { CampaignEditController } from './pages/campaign-edit/campaign-edit.controller'

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  '$translate',
  'ToastService',
  ($q, $state, $rootScope, $translate, ToastService) => {
    const deferred = $q.defer()

    Promise.all([
      $rootScope.getUser()
    ]).then(([oUser]) => {
      if (!$rootScope.isUserSysAdminAdmin(oUser)) {
        deferred.reject()
      } else {
        deferred.resolve()
      }
    })

    return deferred.promise
      .catch(() => {
        ToastService.showErrorToast($translate.instant('campaign.accessModuleValidation.userForbiddenToast'))

        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider) {
  $stateProvider
    .state('campaigns', {
      url: '/campaigns',
      reloadOnSearch: false,
      views: {
        '': {
          templateUrl: '/campaigns/campaigns.html?$$REVISION$$',
          controller: CampaignsController
        }
      },
      resolve: {
        checkModuleEnabled
      }
    })
    .state('campaigns-edit', {
      url: '/campaigns/:id?activeTab',
      params: {
        id: null,
        campaign: null,
        activeTab: ''
      },
      reloadOnSearch: false,
      data: {
        type: 'CAMPAIGN'
      },
      views: {
        '': {
          templateUrl: '/campaigns/pages/campaign-edit/campaign-edit.html?$$REVISION$$',
          controller: CampaignEditController
        }
      },
      resolve: {
        checkModuleEnabled
      }
    })
}

export const campaignsRoutes = routes
